module.exports = __webpack_public_path__ + "img/Verrière d_intérieur.0ba79568.jpg";